export default function createVimeoContentStyle({ videoHeight }) {
  return {
    border: 0,
    height: videoHeight,
    width: '100%'
  };
}
